export function ProfessionalDirectoryHeader() {
  return (
    <header className="mb-8 text-center lg:text-left">
      <h1 className="text-2xl md:text-3xl font-semibold text-foreground mb-3">
        Find Professional Care Partners
      </h1>
      <p className="text-muted-foreground text-lg max-w-2xl">
        Connect with licensed professionals for occupational therapy, physical therapy, home safety assessments, and more.
      </p>
    </header>
  );
}